import { updateObject } from "../unitily";

const save = (state, action) => {
  return updateObject(state, {
    ...action.payload.value
  });
};

export { save };
